import i18next from '../../locale/i18n';

export interface IService {
    id: number;
    name: string;
    link: string;
    isLocal?: boolean;
}

const serviceList: IService[] = [
    {
        id: 1,
        name: i18next.t('calendar'),
        link: "/calendar",
        isLocal: true,
    },
    {
        id: 2,
        name: i18next.t('hotel_service'),
        link: "https://zaer.razavi.ir",
    },
    {
        id: 3,
        name: i18next.t('live_service'),
        link: "",
    },
    {
        id: 4,
        name: i18next.t('charity_service'),
        link: "https://nazr.razavi.ir/pay",
    },
    {
        id: 5,
        name: i18next.t('treasure_image'),
        link: "http://video.novinrazavi.ir/home",
    },
    {
        id: 6,
        name: i18next.t('treasure_audio'),
        link: "http://music.novinrazavi.ir/home",
    },
    {
        id: 7,
        name: i18next.t('pray_service'),
        link: "",
    },
    {
        id: 8,
        name: i18next.t('routing'),
        link: "",
    },
    {
        id: 9,
        name: i18next.t('shrine_programs'),
        link: "",
    },
    {
        id: 10,
        name: i18next.t('calture_competition'),
        link: "",
    },
    {
        id: 11,
        name: i18next.t('pilgrimage'),
        link: "",
    },
    {
        id: 12,
        name: i18next.t('city_map'),
        link: "",
    },
    {
        id: 13,
        name: i18next.t('getting_to_know_imam_reza'),
        link: "",
    },
    {
        id: 14,
        name: i18next.t('question_sevice'),
        link: "",
    },
    {
        id: 15,
        name: i18next.t('pilgrim_guide'),
        link: "",
    },
    {
        id: 16,
        name: i18next.t('food_service'),
        link: "https://app.nasimrezvan.com/mehmansara",
    },
    {
        id: 17,
        name: i18next.t('mashhad_parking'),
        link: "",
    },
    {
        id: 18,
        name: i18next.t('selected_videos'),
        link: "",
    },
    {
        id: 19,
        name: i18next.t('public_supervision'),
        link: "",
    },
    {
        id: 20,
        name: i18next.t('library_service'),
        link: "https://register.library.razavi.ir/azarsa-astan-register",
    },
    {
        id: 21,
        name: i18next.t('military_service'),
        link: "https://khedmat.razavi.ir/register",
    },
    {
        id: 22,
        name: i18next.t('marrige_service'),
        link: "https://kouthar.razavi.ir/aghd/",
    },
    {
        id: 23,
        name: i18next.t('museum_service'),
        link: "https://digimuseum.razavi.ir",
    },
    {
        id: 24,
        name: i18next.t('estate_service'),
        link: "",
    },
    {
        id: 25,
        name: i18next.t('virtual_pilgrimage'),
        link: "",
    },
    {
        id: 26,
        name: i18next.t('conseling_center'),
        link: "",
    },
    {
        id: 27,
        name: i18next.t('servant_service'),
        link: "https://khademyar.razavi.ir/panel/f?p=100%3A101",
    },
    {
        id: 28,
        name: i18next.t('handling_complaints'),
        link: "https://shekayat.razavi.ir/register",
    },
]

export default serviceList;